import React, { useState, useEffect } from 'react';
import { LazyVideo } from '../common/LazyVideo';

export function GifContainer() {
  const [isDark, setIsDark] = useState(true);

  // Detect theme change and initialize
  useEffect(() => {
    // Check for dark mode
    const checkDarkMode = () => {
      const isDarkMode = document.documentElement.classList.contains('dark');
      setIsDark(isDarkMode);
    };

    // Initial check
    checkDarkMode();

    // Set up listeners for changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.attributeName === 'class' &&
          mutation.target === document.documentElement
        ) {
          checkDarkMode();
        }
      });
    });

    // Start observing document for class changes
    observer.observe(document.documentElement, { attributes: true });

    return () => {
      observer.disconnect();
    };
  }, []);


  return (
    <div className="relative rounded-2xl p-1.5 overflow-visible">
      {/* Glow effect */}
      <div className="absolute -inset-2 bg-gradient-to-r from-primary-light via-secondary-light to-primary-light dark:from-primary-dark dark:via-secondary-dark dark:to-primary-dark opacity-20 blur-xl animate-gradient bg-[length:200%_auto]" />

      {/* Glassy border with flowing colors - improved performance */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-background-light/50 to-surface-light/50 dark:from-background-dark/50 dark:to-surface-dark/50 backdrop-blur-sm border border-white/20 dark:border-white/10">
        {/* Animated gradient border - with performance optimizations */}
        <div className="absolute inset-0 rounded-2xl overflow-hidden">
          <div
            className="absolute -inset-[200%] animate-spin-clockwise will-change-transform"
            style={{
              background: `conic-gradient(from 0deg at 50% 50%,
                rgba(37,99,235,0.5) 0deg,
                rgba(16,185,129,0.5) 120deg,
                rgba(37,99,235,0.5) 240deg,
                rgba(37,99,235,0.5) 360deg
              )`,
              transformOrigin: 'center',
              animationDuration: '12s' // Slightly faster animation
            }}
          />
        </div>
      </div>

      {/* Glass container */}
      <div className="relative rounded-xl overflow-hidden aspect-[3/2] md:aspect-[3/2] backdrop-blur-md shadow-[0_8px_32px_rgba(37,99,235,0.15)] dark:shadow-[0_8px_32px_rgba(59,130,246,0.15)]">
        <LazyVideo
          darkSrc=""
          lightSrc=""
          videoKey="smallint"
          isDark={isDark}
          className="rounded-xl"
          autoPlay={true}
          muted={true}
          loop={true}
          playsInline={true}
        />
      </div>
    </div>
  );
}